import { SagaIterator } from 'redux-saga';
import { all, call, CallEffect, fork, put, takeEvery } from 'redux-saga/effects';
import { Messages } from '../../codegen/Localize';
import { Tableau } from '../../common/utilities/TableauLog';
import { IToastOptions, ToasterService, ToastType } from '../../ts/services/ToasterService';
import { RequestFailed } from '../actions/AppActionTypes';
import { Failure, RequestFailedAction } from '../actions/RequestFailedAction';

export function popToast(toast: IToastOptions) {
  const service = ToasterService.instance;
  service.pop(toast);
}

export function logError(failure: Failure) {
  if (failure.error) {
    Tableau.Logger().error(failure.error);
  } else {
    Tableau.Logger().error(failure.reason);
  }
}

export function* processFailedRequest(action: RequestFailedAction) {
  if (action.failure.isDismissDialog) {
    return;
  }

  yield call(logError, action.failure);
  yield call(popToast, {
    text: action.localizedMessage ? action.localizedMessage : Messages.errorUnknown(),
    type: ToastType.Error
  });
}

export function* rootRequestFailedSaga(): SagaIterator {
  yield takeEvery(RequestFailed, processFailedRequest);
}
